export const getCurrencySymbol = function (currency: string) {
  const numberFormat = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol'
  })

  return numberFormat.formatToParts(0).find(p => p.type === 'currency')?.value
}

const getCurrencyName = function (currency: string) {
  const numberFormat = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    currencyDisplay: 'name'
  })

  return numberFormat
    .formatToParts(0)
    .find(p => p.type === 'currency')
    ?.value.replace(/^\w/, c => c.toUpperCase())
}

export const currencies = Intl.supportedValuesOf('currency')
  .map(function (curr) {
    return {
      label: `${getCurrencyName(curr)} (${getCurrencySymbol(curr)})`,
      value: curr
    }
  })
  .toSorted((a, b) => a.label.localeCompare(b.label))

export const timezones = Intl.supportedValuesOf('timeZone').map(function (tz) {
  return {
    label: tz,
    value: tz,
    group: tz.split('/')[0]
  }
})
